import { useTheme } from '@mui/material/styles';
import { useMemo } from 'react';
import { StylesType } from './types/style.types';
import { commonStyles } from './common-styles.utils';

export const useStyles = <
	StyleDeps extends unknown[],
	StyleFuncType extends StylesType<StyleDeps>,
	Result = ReturnType<StyleFuncType>,
	CommonType = ReturnType<typeof commonStyles>,
	Both = CommonType & Result
>(
	styleFunc?: StyleFuncType,
	...styleDeps: StyleDeps
): Both => {
	const theme = useTheme();

	// eslint-disable-next-line react-hooks/exhaustive-deps
	const styles = useMemo<Both>(
		() =>
			({
				...(commonStyles(theme) as unknown as CommonType),
				...(styleFunc?.(theme, ...styleDeps) as unknown as Result),
			} as unknown as Both),
		[styleDeps, styleFunc, theme]
	);

	return styles as Both;
};
